import { render, staticRenderFns } from "./ChooseOwnModal.vue?vue&type=template&id=36434ba9"
import script from "./ChooseOwnModal.vue?vue&type=script&lang=js"
export * from "./ChooseOwnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports